module.exports = __webpack_public_path__ + "static/img/btn_logo_nor.e6de66e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/almaMater/btn_logo_nor.png
// module id = Vrde
// module chunks = 1